//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { register, queryAgentBonus, queryRegisterItem ,registerPhoneCode, registeredphone} from '@/common/api/system.js'
  import { compare } from '@/common/utils/'
  import { registerRF, registerR, checkDisparity, requiredBlur } from '../../libs/rule-form.js'
  import getMsgMx from '@/common/mixin/getMsg.js'
  import systemFormMx from '../mixins/system-form.js'
  import { initAgentCode } from '@/common/utils/initRegisterAgentCode.js'
  import styleControlMX from '../mixins/formStyleChange2.js'
  import fetchImgMX from '@/common/mixin/getfetchImg.js'
  export default {
    name: 'newRegister',
    inject: ['parentRoot','parentCom'],
    mixins: [fetchImgMX ,getMsgMx, systemFormMx, styleControlMX(registerRF)],
    data() {
      return {
        ruleForm: Object.assign({}, registerRF),
        rules: registerR(this),
        RegisterList: [ // 表单动态项
          { lengthMin: 6, lengthMax: 10, requireSwitch: '1', sort: -2, typeName: "phone", isShow: true },
          { lengthMin: 6, lengthMax: 12, requireSwitch: '1', sort: -2, typeName: "username", isShow: true },
          { lengthMin: 6, lengthMax: 12, requireSwitch: '1', sort: -1, typeName: "password", isShow: true },
          { lengthMin: 6, lengthMax: 12, requireSwitch: '1', sort: 0, typeName: "repeatPassword", isShow: true },
          { lengthMin: 0, lengthMax: 12, requireSwitch: '1', sort: 99, typeName: "vrifyCode", isShow: true },
        ],
        isAgree: true,

        bonusVisible: false,
        dialogIsShow: false,
        isSendYzm: false, // 是否正在发送短信验证码
        countDownTime: 60, // 短信验证倒计时
        titleImg:''
      }
    },
    computed: {
      isPhoneCode() { // 是否发送短信验证码 1 是 0 否
        return this.$store.state.linkList.hasSendPhoneCode === '1'
      },
      isPhoneVerifyT(){   //是否开启手机验证码  2 是
        return this.$store.state.linkList.isPhoneVerifyT === '2'
      },
      customRegisterItem() { // 注册项是否显示
        let obj = {}
        if (this.RegisterList.length > 0) {
          this.RegisterList.forEach((item) => {
            if (item.typeName === 'phoneNumber') item.typeName = 'phone'
            obj[item.typeName] = { ...item, require: item.requireSwitch === '1' ? true : false, isShow: true } // 是否必填
              if (item.typeName == 'username' || item.typeName == 'repeatPassword') {
                obj[item.typeName].require = false
                obj[item.typeName].isShow = false
              }
              if (item.typeName == 'phone') obj[item.typeName].require = true
          })
            // const obj1 = { phone: { isShow: true, ...obj.phone }, vrifyCode: { isShow: true, ...obj.vrifyCode } }
            // delete obj.phone
            // delete obj.vrifyCode
            // obj = { ...obj1, ...obj }
        }
        return obj
      }
    },
    created() {
      const checkPwdFn = checkDisparity({ that: this, objName: 'ruleForm', keyName1: 'password', keyName2: 'repeatPassword' })
      this.rules.password[1] = { validator: checkPwdFn.validate1, trigger: 'blur' }
      this.rules.repeatPassword[1] = { validator: checkPwdFn.validate2, trigger: 'blur' }

      initAgentCode(this) // 初始化 agentCode
      this.initFormControl('agentCode')

      this.$set(this.ruleForm, 'regDomain', document.domain)
      // this._getRegisterList()
      
      this._getfetchImg('registerAndLoginBanner') // 获取logo
      
    },
    methods: {
      implementationFetched([data, res], imgCode) {
        this.titleImg = data[0]['imgLink']
      },
      async _submit() { // 注册
        if (!this.isAgree) {
          this.$showToast({ text: this.$t('Forms').agreeTips, type: 'cancel'})
          return
        }
        // if (this.isPhoneVerify === '3') this.$set(this.ruleForm, 'repeatPassword', this.ruleForm.password)
        this.$set(this.ruleForm, 'repeatPassword', this.ruleForm.password)
        this.$set(this.ruleForm, 'username', this.ruleForm.phone)
        this.$set(this.ruleForm, 'registerType', '1')
        this.submitLoading = true
        const [data, err, res] = await registeredphone({ ...this.ruleForm })
        this.submitLoading = false
        if (!err) {
          let UUID = res.data.data
          this.$Cookies.set('UUID', UUID)
          let timer = setTimeout(() => {
            this.$store.dispatch('Login', UUID)
            this.$store.dispatch('refreshUserInfo', 1) // 登录时候获取用户信息
            // this._queryAgentBonus()
            this.$store.commit('setRegisterAgentCode') // 清除code
            this.$router.replace({ path: '/' })
             //上报注册成功
            // actionLogEvent("af_complete_registration")  //老包
            // setTimeout(() => {
            //   actionLogEvent("af_register")  //新包
            // }, 1500);
            actionLogEvent("af_register")  //新包
            clearTimeout(timer)
          },300)
        } else {
          this.$showToast({ text: res.data.msg, type: 'cancel'});
          // if(this.$refs.gVrifycodeEle) this.$refs.gVrifycodeEle[0].handleVifyCode()
        }
      },
      handleSendCode() {
        this.$set(this.ruleForm, 'phone', this.ruleForm.phone.replace(/(^\s*)|(\s*$)/g, ""))
        this.$refs['ruleForm'].validateField('phone', phoneError => { // 验证手机号码是否正确
          if (!phoneError) {
            if (this.isSendYzm) return
            this.isSendYzm = true
            registerPhoneCode({ phoneNum: this.ruleForm.phone }).then(([data, err, res]) => {
              if (!err) {
                console.log(data)
              } else {
                this.$showToast({ text: res.data.msg, type: 'warn' })
                this.countDownFinsh()
              }
            })
          } else {
            return false
          }
        })
      },

      countDownFinsh() { // 结束验证倒计时
        this.isSendYzm = false
        this.countDownTime = 60
      },

      async _getRegisterList() { // 获取自定义注册列表
        this.$store.commit('setPageLoading', true)
        const [data, err] = await queryRegisterItem()
        this.$store.commit('setPageLoading', false)
        if (!err) this.RegisterList = [...this.RegisterList, ...data].sort(compare('sort', true))
      },

      async _queryAgentBonus() { // 查询注册用户是否为代理注册
        const [data, err, res] = await queryAgentBonus({ agentCode: this.ruleForm.agentCode })
        if (!err) {
          this.bonusVisible = data.length > 0
          this.dialogIsShow = data.length <= 0
        } else {
          this.$router.replace({ path: '/' })
        }
      },

      handleJump(path) { // 跳转新页面
        if (this.bonusVisible) this.bonusVisible = false
        if (this.dialogIsShow) this.dialogIsShow = false
        if (path === '/') path = this.successPath + ''
        this.$router.replace({ path })
      },

      handleLiveChat() { // 打开livechat
        if (window.LiveChatWidget) {
          this.$router.replace({ path: '/Service' })
          window.LiveChatWidget.call('maximize')
        }
      }
    }
  }



// WEBPACK FOOTER //
// ./src/pages/build800/views/newregister/index.vue